import React, { Component } from 'react';
import { Header, List, Table } from 'semantic-ui-react';

export default class FinalPresentationPage extends Component {
  render() {
    return (
      <div>
        <Header as="h1" content="Final presentations" />
        <p>
          <b>Due Date:</b>
          4/19/22
        </p>

        <p>
          At the end of the semester, you will present the results of your research to the class.
          Feel free to invite interested friends and colleagues to attend!
        </p>

        <p>
          Here are some things to keep in mind:
        </p>

        <List bulleted>
          <List.Item>Half of the groups will present on 4/19, and the other half on 4/21. The order will be randomly determined. All groups must submit their presentation slides by 4/19.</List.Item>
          <List.Item>The time allotted to each group is <strong>TBD</strong> (depending on the number of groups).</List.Item>
          <List.Item>Test (and debug) your laptop video projection before presentations begin.</List.Item>
          <List.Item>Structure your presentation like an hourglass — motivate the problem broadly and explain why you think it's important, drill down into the details of what you did and found, and then discuss the broader implications of your work.</List.Item>
          <List.Item>If you are nervous about giving presentations, you can can write out everything you want to say long-hand. This will allow you to convey information efficiently and effectively. Read through it enough times so that you have it basically memorized, but not so memorized that you get flustered if you skip a word or someone asks a question.</List.Item>
          <List.Item>Know your audience! You can expect that everyone in the class knows everything you learned in class. So, you don't need to re-introduce the whole field of usable privacy and security. A sentence or two to situate your work in the field is good, but spend the rest of the time telling us what you did.</List.Item>
          <List.Item>When presenting, try to stand near your slides. And look at the audience.</List.Item>
        </List>

        <Header as="h3" content="Grading" />
        <p>
          You can earn up to 10 points for the assignment along the following three dimensions: clarity, effectiveness and timing.
          Refer to the following rubric for more specific information:
        </p>

        <Table definition>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell />
              <Table.HeaderCell>Insufficient</Table.HeaderCell>
              <Table.HeaderCell>Adequate</Table.HeaderCell>
              <Table.HeaderCell>Proficient</Table.HeaderCell>
              <Table.HeaderCell>Mastery</Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>
            <Table.Row>
              <Table.Cell>Clarity (4 pts)</Table.Cell>
              <Table.Cell><b>1</b>: The research question, method and results are unclear.</Table.Cell>
              <Table.Cell><b>2</b>: The basic thesis of the work was communicated, but major components were buried or confusing.</Table.Cell>
              <Table.Cell><b>3</b>: The main ideas were clear, but the details were confusing, incomplete, or signaled a misunderstanding.</Table.Cell>
              <Table.Cell><b>4</b>: The presentation clearly sets out the project's goals, results, and implications, and all details were clear.</Table.Cell>
            </Table.Row>

            <Table.Row>
              <Table.Cell>Effectiveness (4 points)</Table.Cell>
              <Table.Cell><b>1</b>: The presentation was unconvincing in its communication of the core problem, question, and solution.</Table.Cell>
              <Table.Cell><b>2</b>: The presentation was unconvincing in its communication of at least one of the core problem, question, or solution.</Table.Cell>
              <Table.Cell><b>3</b>: The presentation made a reasonable case for the importance, novelty and validity of the research. There was at least one noticeable weak point in the argument.</Table.Cell>
              <Table.Cell><b>4</b>: The presentation made a strong case for all aspects of the project, and did so with forcefulness or flair.</Table.Cell>
            </Table.Row>

            <Table.Row>
              <Table.Cell>Timing (2 points)</Table.Cell>
              <Table.Cell colSpan={2}><b>1</b>: The presentation ran out of time or misappropriated time between components of the research.</Table.Cell>
              <Table.Cell colSpan={2}><b>2</b>: Balanced coverage of introduction, idea, system or study design, and results.</Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/group-project-assignments/final-presentation-page.js